import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import { BackResponseFailure } from '@savgroup-front-common/types';

// eslint-disable-next-line max-len
const ENDPOINT = `${APIConfiguration.import}console/${COMMON_QUERY_PARAMS.SELLER_ID}/download/${COMMON_QUERY_PARAMS.CONSOLE_ENTITY_DEFINITION}`;

interface GetFileConfigurationDownloadQueryArgs {
  sellerId: string;
  importType: string;
  ruleSetId?: string;
}

async function getFileConfigurationDownloadQuery({
  sellerId,
  importType,
  ruleSetId,
}: GetFileConfigurationDownloadQueryArgs): Promise<Blob | BackResponseFailure> {
  try {
    return await apiCall<Blob>(
      buildUrl(
        ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId).replace(
          COMMON_QUERY_PARAMS.CONSOLE_ENTITY_DEFINITION,
          importType,
        ),
        {
          ruleSetId,
        },
      ),
      {
        method: SUPPORTED_METHODS.GET,
        responseType: 'blob',
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getFileConfigurationDownloadQuery;
